export const en = {
  viewSession: 'View session',
  fullStoryTitle: 'FullStory',
  logRocketTitle: 'LogRocket'
};

export type Translations = typeof en;
